import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, Input, ViewChild } from '@angular/core';
import { ContactoService } from '../../../providers/contacto.service';
import { UploaderComponent } from '../../archivo/uploader/uploader.component';
import { OnInit } from '@angular/core/public_api';
// import { ContactoComponent } from '../../contacto/contacto.component';

@Component({
  selector: 'importar-dialog',
  templateUrl: './importar-dialog.component.html',
  styleUrls: ['./importar-dialog.component.scss']
})
export class ImportarDialog implements OnInit{
  error: string = '';
  cargando: boolean = false;
  hay_archivo: boolean = false;

  tipo: string = '';

  fileToUpload: File | null = null;

  // referencia a si mismo para poder cerrar el dialog...etc.
  @ViewChild('uploaderEspecificacionTecnica') uploaderEspecificacionTecnica: UploaderComponent;
  constructor(
    public dialogCrear: MatDialogRef<ImportarDialog>,
    public contactSv: ContactoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  ngOnInit() {
    if(this.data.tipo){
      this.tipo = this.data.tipo;
    }
  }

  onContactoInput() { // si cambian los datos ingresados
    this.error = ''; // limpiamos los mensajes de error del formulario
  }

  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onCrear(): void {

    this.uploaderEspecificacionTecnica.uploadAll().subscribe(
      (uploaded) => {
        // console.log(uploaded);
        this.dialogCrear.close();
      }
    );
  }


  archivoCargado(event){
    // console.log('evento', event);

    this.hay_archivo=event;
  }

  descargarPlantilla (){
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    if(this.tipo == 'dato'){
      link.setAttribute('href', './assets/plantilla_carga.xlsx');
    }else{
      link.setAttribute('href', './assets/plantilla_carga_contacto.xlsx');
    }
    link.setAttribute('download', `plantilla.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
